import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import { LogoDisplay } from 'web-ui-components/lib/transactions/logo';

import { BDataGrid } from '../../common/dataGrid/BDataGrid';
import TransactionDetailsStaticUtils from '../../../utils/TransactionDetailsStaticUtils';
import TransactionsStoreNew from '../../../stores/TransactionsStoreNew';
import AccountsStore from '../../../stores/AccountsStore';
import AccountPoolsStore from '../../../stores/AccountPoolsStore';
import LoaderComponent from '../../common/LoaderComponent';
import StringConstants from '../../../constants/StringConstants';
import { isBOrVMRetail, isVM } from '../../../utils/BrandUtils';
import { TransactionRefundRowDetails } from './TransactionRefundRowDetails';
import { TransactionMoreDetailsButton } from './TransactionMoreDetailsButton';

let columnsList = TransactionDetailsStaticUtils.getColumnListData();
let columnMetadata = TransactionDetailsStaticUtils.getColumnMetaData();

class TransactionGridComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.loadNextTransactions = this.loadNextTransactions.bind(this);
    this.customTagComponent = this.customTagComponent.bind(this);
    this.customBalanceComponent = this.customBalanceComponent.bind(this);
    this.onRowSelectAll = this.onRowSelectAll.bind(this);
    this.customLoadingComponent = this.customLoadingComponent.bind(this);
  }

  loadNextTransactions() {
    this.props.loadNextTransactions();
  }

  customTagComponent(props) {
    let click = this.props.onTableTagClick.bind(this, props.rowData);

    if (props.rowData.posted) {
      return props.data !== 'Untagged' ? (
        <span className={`${props.rowData.archived ? 'archived-tag' : ''}`}>
          <span aria-hidden="True" className="icon icon-tag" />
          <span aria-label="Tag icon" onClick={click}>
            {props.data}
          </span>
        </span>
      ) : (
        <span
          onClick={click}
          className="add-tag-grid"
          aria-label="Add Tag icon"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 512 512"
          >
            <path d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208c114.9 0 208-93.1 208-208S370.9 48 256 48zM384 265H264v119h-17V265H128v-17h119V128h17v120h120V265z" />
          </svg>
        </span>
      );
    } else {
      return <span />;
    }
  }

  customLoadingComponent() {
    if (!this.props.transactionServiceErrorFlag) {
      return <LoaderComponent type="small" />;
    } else {
      return (
        <div className="u-text-center">
          <div>
            {this.props.statusErrorResponse === 408
              ? this.props.content.transactionsErrorBody
              : this.props.transactionServiceErrorMessage}
          </div>
          <button
            className="c-btn c-btn--default"
            onClick={this.props.onRetryClick}
          >
            {this.props.statusErrorResponse === 408
              ? this.props.content.transactionsErrorButtonTitle
              : 'Retry'}
          </button>
        </div>
      );
    }
  }

  getFooter() {
    let showFooter = false;
    !this.props.isLoading && this.props.data.length === 0
      ? (showFooter = false)
      : (showFooter = !this.props.isLoading);
    return showFooter;
  }

  customBalanceComponent(props) {
    let clickOnBalance = this.props.onRowClick.bind(this, props.rowIndex);
    if (!props.rowData.posted) {
      return (
        <div
          className="transaction-pending"
          onClick={this.props.openTransactionInProgressPopUp}
        >
          <svg
            role="presentation "
            aria-label="Your Transaction is pending"
            enableBackground="new 0 0 91 91"
            height="28px"
            id="Layer_1"
            version="1.1"
            viewBox="0 0 91 91"
            width="28px"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g>
              <path d="M45.2,18.577c-15.243,0-27.645,12.404-27.645,27.646c0,15.244,12.401,27.646,27.645,27.646   c15.244,0,27.645-12.402,27.645-27.646C72.845,30.981,60.444,18.577,45.2,18.577z M45.2,70.47   c-13.368,0-24.244-10.875-24.244-24.246c0-13.369,10.876-24.246,24.244-24.246c13.369,0,24.245,10.877,24.245,24.246   C69.445,59.595,58.569,70.47,45.2,70.47z" />
              <polygon points="46.985,26.272 43.585,26.272 43.585,47.925 54.485,47.925 54.485,44.524 46.985,44.524  " />
              <rect height="4.424" width="3.4" x="43.585" y="61.72" />
              <rect height="3.4" width="4.36" x="25.229" y="44.524" />
              <rect height="3.4" width="4.36" x="60.813" y="44.524" />
              <rect
                height="3.402"
                transform="matrix(0.7378 0.6751 -0.6751 0.7378 31.4782 -12.701)"
                width="4.36"
                x="29.907"
                y="32.465"
              />
              <rect
                height="3.401"
                transform="matrix(-0.738 -0.6748 0.6748 -0.738 62.1598 140.4834)"
                width="4.356"
                x="56.174"
                y="56.474"
              />
              <rect
                height="4.361"
                transform="matrix(-0.7377 -0.6751 0.6751 -0.7377 17.6811 125.4726)"
                width="3.399"
                x="31.514"
                y="57.121"
              />
              <rect
                height="4.36"
                transform="matrix(0.7377 0.6751 -0.6751 0.7377 37.3121 -29.9663)"
                width="3.399"
                x="55.523"
                y="30.858"
              />
            </g>
          </svg>
        </div>
      );
    } else {
      return <span onClick={clickOnBalance}>{props.rowData.balance}</span>;
    }
  }

  customMoreDetailsComponent = ({ rowIndex, rowData }) => (
    <TransactionMoreDetailsButton
      onClick={() =>
        this.props.onMoreDetailsClick({
          rowClickIndex: rowIndex,
          selectedTransactionId: rowData.id,
        })
      }
    />
  );

  customLogoComponent = ({ rowData }) => {
    const logoInitials = rowData.isDescriptionEnriched
      ? rowData.description.charAt(0).toUpperCase()
      : rowData.merchantName.charAt(0).toUpperCase();

    const logoSrc = rowData.logo?.url;
    return (
      <LogoDisplay
        imageSource={logoSrc}
        initials={logoInitials}
        alt={rowData.logo?.altTextTag}
        isSquare={!!logoSrc}
        isSmall
      />
    );
  };

  useCustomChildRow(rowData) {
    return rowData?.isRefund && !rowData?.posted;
  }

  onRowSelectAll(props, isSelected) {
    let selectAllArray = [];
    let isSelectedFlag = false;
    if (isSelected) {
      if (this.props.data.length > 0) {
        selectAllArray = this.props.data
          .filter(({ posted }) => posted)
          .map(({ id, tagId }) => ({
            id,
            tagId,
          }));

        isSelectedFlag = true;
      } else {
        selectAllArray = [];
        isSelectedFlag = true;
      }
    } else {
      selectAllArray = [];
      if (this.props.data.length > 0) {
        isSelectedFlag = false;
      } else {
        isSelectedFlag = true;
      }
    }
    this.props.onRowSelectAll(selectAllArray, isSelectedFlag);
  }

  render() {
    const tagMetadata = _.find(columnMetadata, { columnName: 'tag' });
    tagMetadata.customComponent = this.customTagComponent;
    const balanceMetadata = _.find(columnMetadata, { columnName: 'balance' });
    balanceMetadata.customComponent = this.customBalanceComponent;

    const moreColumnMetadata = _.find(columnMetadata, { columnName: 'more' });
    moreColumnMetadata.customComponent = this.customMoreDetailsComponent;

    const logoColumnMetadata = _.find(columnMetadata, { columnName: 'logo' });
    logoColumnMetadata.customComponent = this.customLogoComponent;

    if (
      TransactionsStoreNew.getTransactionAmountLength() ||
      TransactionsStoreNew.getTransactionBalanceLength()
    ) {
      const amountTag = _.find(columnMetadata, { columnName: 'amount' });
      if (amountTag)
        amountTag.cssClassName = 'transaction__amount__column amount-max-width';
      const dateTag = _.find(columnMetadata, { columnName: 'date' });
      dateTag.cssClassName = 'transaction__date__column date-max-width';
      const descriptionTag = _.find(columnMetadata, {
        columnName: 'description',
      });
      descriptionTag.cssClassName =
        'transaction__description__column description-max-width';
      const tagTag = _.find(columnMetadata, { columnName: 'tag' });
      tagTag.cssClassName = 'transaction__tag__column tag-max-width';
      const typeTag = _.find(columnMetadata, { columnName: 'type' });
      typeTag.cssClassName = 'transaction__type__column type-max-width';
      const balanceTag = _.find(columnMetadata, { columnName: 'balance' });
      balanceTag.cssClassName =
        'transaction__balance__column balance-max-width';
    }
    let noDataText = '';
    this.props.transactionReadFlag
      ? (noDataText = this.props.content.noTransactionFound)
      : (noDataText = this.props.content.noTransactionMessage);
    if (isBOrVMRetail()) {
      columnsList = TransactionDetailsStaticUtils.getColumnListData();
    } else if (AccountPoolsStore.isSpecificPoolDetailsLoaded()) {
      columnsList =
        TransactionDetailsStaticUtils.getColumnListDataForSMEAccountPools();
    } else {
      columnsList = TransactionDetailsStaticUtils.getColumnListDataForSME();
    }
    if (this.props.accountType === 'credit_card') {
      _.pull(columnsList, 'balance');
    }

    if (this.props.isAccountPool) {
      columnsList.push('account');
      _.pull(columnsList, 'tag');
    } else {
      const accDetails = AccountsStore.getAccountDetail(this.props.account);
      if (accDetails.product.code === StringConstants.KAPITI_PRODUCT_CODE) {
        _.pull(columnsList, 'balance');
        _.pull(columnsList, 'tag');
      }
      if (
        accDetails &&
        !accDetails.actionsAvailable['/account/transactions/write']
      ) {
        _.pull(columnsList, 'tag');
      }
    }

    const pendingTransactions = this.props.data.filter(({ posted }) => !posted);
    const postedTransactions = this.props.data.filter(({ posted }) => posted);
    const orderedDataResults = pendingTransactions.concat(postedTransactions);

    return (
      <div
        className={cx('oldTable', {
          'enriched-view': !AccountPoolsStore.isSpecificPoolDetailsLoaded(),
        })}
      >
        <BDataGrid
          ref="TransactionHistoryGrid"
          results={orderedDataResults}
          columns={columnsList}
          columnMetadata={columnMetadata}
          content={this.props.content}
          bodyHeight={400}
          selectedRowIds={this.props.selectedRowIds}
          externalIsLoading={this.props.isLoading}
          externalLoadingComponent={this.customLoadingComponent}
          useCustomPagerComponent={false}
          initialSortAscending={false}
          initialSort="date"
          useFixedHeader
          resultsPerPage={this.props.data.length}
          rowExpander
          showNoData
          rowSelected={this.props.onRowSelect}
          rowAllSelected={this.onRowSelectAll}
          isFooterEnabled={this.getFooter()}
          gridFooterCss={
            isVM() ? undefined : 'callout callout__full callout__txt-center'
          }
          onFooterClick={this.loadNextTransactions}
          onSort={this.props.onSort}
          showPager={false}
          noDataMessage={noDataText}
          loadTransactionsFlag={this.props.loadTransactionsFlag}
          isMultipleSelection={this.props.isMultipleSelection}
          rowCustomClass={this.props.rowCustomClass}
          onRowClick={this.props.onRowClick}
          rowClickIndex={this.props.rowClickIndex}
          customChildRow={
            <TransactionRefundRowDetails content={this.props.content} />
          }
          customChildRowContainerClass="transaction-refund-row"
          useCustomChildRow={this.useCustomChildRow}
          thatsAllMessage={
            TransactionsStoreNew.hasReachedLookupLimit()
              ? this.props.content.transactionsLookupLimitError
              : undefined
          }
        />
      </div>
    );
  }
}

TransactionGridComponent.propTypes = {
  content: PropTypes.object,
  transactionReadFlag: PropTypes.bool,
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  loadNextTransactions: PropTypes.func,
  onMoreDetailsClick: PropTypes.func,
  onSort: PropTypes.func,
  accountType: PropTypes.string,
};

export default TransactionGridComponent;
